import {
  artworkRequired,
  isArtworkDelivered,
  SERVICES,
  isLineItemCancelled,
  hasActiveArtworkServiceOfTypes,
} from '@printdeal/business-logic';

import { SanitizedLineItem, SanitizedOrder } from '../../../../../../../types/order/Order';
import { Environment } from '../../../../../../../helpers/env';
import {
  hasSubmittedServiceRequestDetails,
} from '../../../../../../../helpers/artworkHelper';

export const ReasonsDisabled = {
  ARTWORK_DELIVERED: 'We have delivered the required artwork',
  ARTWORK_UNNECESSARY: 'The product does not require artwork',
  LINE_ITEM_CANCELLED: 'The lineItem has already been cancelled',
  REQUEST_DETAILS_SUBMITTED: 'The art service request details have already been submitted',
  SERVICE_NOT_NEEDED: 'The customer has not asked for this service',
};

const canRequestFileDesignHelper = (lineItem: SanitizedLineItem, order: SanitizedOrder) => {
  if (!artworkRequired(lineItem)) {
    // Some products cannot be printed on.
    return {
      hasService: false,
      enabled: false,
      reasonDisabled: ReasonsDisabled.ARTWORK_UNNECESSARY,
    };
  }

  if (isLineItemCancelled(lineItem, Environment)) {
    // The lineItem has been cancelled. Whether it had an art service is not relevant.
    return {
      hasService: false,
      enabled: false,
      reasonDisabled: ReasonsDisabled.LINE_ITEM_CANCELLED,
    };
  }

  if (!hasActiveArtworkServiceOfTypes(lineItem.id, order, [SERVICES.FILE_DESIGN], Environment)) {
    // The customer has not requested this particular service, or the request was cancelled.
    return {
      hasService: false,
      enabled: false,
      reasonDisabled: ReasonsDisabled.SERVICE_NOT_NEEDED,
    };
  }

  if (isArtworkDelivered(lineItem)) {
    // The service was requested, and we have already delivered the artwork.
    return {
      hasService: true,
      enabled: false,
      reasonDisabled: ReasonsDisabled.ARTWORK_DELIVERED,
    };
  }

  if (hasSubmittedServiceRequestDetails(lineItem.id, order, SERVICES.FILE_DESIGN)) {
    // The service was requested, we have not delivered, but the customer has already given us de details.
    return {
      hasService: true,
      enabled: false,
      reasonDisabled: ReasonsDisabled.REQUEST_DETAILS_SUBMITTED,
    };
  }

  // The service was requested & payment has been received, but we still need the request details from the customer.
  return {
    hasService: true,
    enabled: true, // Yes, we need to show the CTA.
  };
};

export default canRequestFileDesignHelper;
